import styled from 'styled-components';

export const StyledMap = styled.section`
    position: relative;
	
	&:after{
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 50%;
		background: #152637;
		z-index: -1;
	}
	

	.image-wrapper-map{
		position: relative;
        padding-top: calc(561 /
        1096 * 100%);
		margin-left: auto;
		margin-left: ${props => props.offset || '15'}px;
	}
`;
